module.exports = __webpack_public_path__ + "static/media/button-selected-all.42770ba2.svg";